import { render } from "./OffcanvasViewForm.vue?vue&type=template&id=4e87aec9&scoped=true"
import script from "./OffcanvasViewForm.vue?vue&type=script&lang=js"
export * from "./OffcanvasViewForm.vue?vue&type=script&lang=js"

import "./OffcanvasViewForm.vue?vue&type=style&index=0&id=4e87aec9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e87aec9"]])

export default __exports__